// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './ResultList.css'

import { bem } from '../../../../helpers/bem'
import { themeToClassName } from '../../../../helpers/themeToClassName'
import { breakpointToClassName } from '../../../../helpers/breakpointToClassName'

import { ScreenReaderList, BarList, TextList } from './components/ResultItem/ResultItem'
import { getMaxLength } from '../../../../helpers/get-text-max-length'
import type { ResultItem as ResultItemType } from '../../../../types'

type State = {
  showNumber: boolean
}

type Props = {
  items: Array<ResultItemType>,
  totalVotes: number,
  highlightedId?: ?number,
  clickable?: boolean
}

export class ResultList extends Component<Props, State> {
  state = {
    showNumber: false
  }
  toggleShowNumber = () => {
    this.setState({ showNumber: !this.state.showNumber })
  }
  render () {
    const { items, totalVotes, highlightedId, clickable } = this.props
    const { showNumber } = this.state
    const { theme, currentBreakpoint } = this.context
    const isSlim = getMaxLength(items, 'votes') > 4

    return (
      // eslint-disable-next-line
      <div
        className={bem(
          styles.resultList,
          themeToClassName(theme),
          breakpointToClassName(currentBreakpoint),
          clickable ? 'clickable' : ''
        )}
        onClick={this.toggleShowNumber}
      >
        <ScreenReaderList items={items} totalVotes={totalVotes} />
        <BarList items={items}
          totalVotes={totalVotes}
          isSlim={isSlim}
          showNumber={showNumber}
          highlightedId={highlightedId} />
        <TextList items={items}
          totalVotes={totalVotes}
          isSlim={isSlim}
          showNumber={showNumber}
          highlightedId={highlightedId} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Result/components/ResultList/ResultList.js